import './components/gallery/_gallery';
import './components/carousel/_carousel';
